<script>
import SiparislerService from "@/services/SiparislerService";
import { ref } from "@vue/composition-api";
import OptionService from "@/services/OptionService";

export default {
  name: "KargoDetayModal",

  props: {
    value: {
      required: true,
      type: Boolean
    },
    orderId: {
      type: Number
    }
  },

  setup() {
    const shippingDetail = ref({
      name: "",
      number: "",
      note: ""
    });
    const shippingLoading = ref(false);
    const shippingUpdateLoading = ref(false);
    let shippingFirms = ref(null);

    OptionService.getInput_Type({
      optionType: "Modules",
      optionName: "general",
      inputName: "shippingFirms"
    }).then(({ status, data }) => {
      if (status === 200) {
        shippingFirms.value = data;
      }
    });

    return {
      shippingDetail,
      shippingLoading,
      shippingUpdateLoading,
      shippingFirms
    };
  },

  methods: {
    getOrderShippingDetail(orderId) {
      this.shippingLoading = true;
      SiparislerService.siparisKargoDetay(orderId).then(({ status, data }) => {
        if (status === 200) {
          const { name, number, note } = data;
          this.shippingDetail.name = name || '';
          this.shippingDetail.number = number || '';
          this.shippingDetail.note = note || '';
        }
        this.shippingLoading = false;
      }).catch(() => {
        this.shippingLoading = false;
      });
    },

    updateShippingDetail() {
      this.shippingUpdateLoading = true;
      SiparislerService.siparisKargoGuncelle({
        orderId: this.orderId,
        shippingName: this.shippingDetail.name,
        shippingNumber: this.shippingDetail.number,
        shippingNote: this.shippingDetail.note
      }).then(({ status, message }) => {
        if (status === 200) {
          this.$snotify.success("Kargo Bilgileri Güncellenmiştir", this.$t("PANEL.NOTIFY.SUCCESS"));
        } else {
          this.$snotify.error(message, this.$t("PANEL.NOTIFY.ERROR"));
        }
        this.shippingUpdateLoading = false;
      }).catch(() => {
        this.shippingUpdateLoading = false;
      });
    }
  },

  watch: {
    orderId() {
      this.shippingDetail.name = "";
      this.shippingDetail.number = "";
      this.shippingDetail.note = "";

      this.getOrderShippingDetail(this.orderId);
    }
  }
};
</script>

<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="400px">
    <v-card color="grey lighten-5" class="pb-1">
      <v-card-title class="align-center">
        <div>
          Kargo Detayları
        </div>
        <v-spacer />
        <div>
          <v-btn icon @click="$emit('input', false)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </v-card-title>
      <v-divider />
      <v-card-text class="pt-5 pb-2">
        <div v-if="shippingLoading" class="d-flex flex-column align-center py-10">
          <v-progress-circular
            size="100"
            indeterminate
            color="primary"
            class="mb-2"
          ></v-progress-circular>
          <div class="text-body-1 font-weight-medium">
            Kargo Bilgileri Yükleniyor
          </div>
        </div>
        <div v-else>
          <v-select v-model="shippingDetail.name" label="Kargo Bilgisi" :items="shippingFirms" outlined solo />
          <v-text-field
            v-model="shippingDetail.number"
            label="Kargo Takip Numarası"
            @keyup="shippingDetail.number = shippingDetail.number.toUpperCase()"
            outlined
            solo
          />
          <v-textarea v-model="shippingDetail.note" label="Kargo notu" outlined solo />
        </div>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn small color="red" dark @click="$emit('input', false)">
          <v-icon size="1.25rem" class="mr-1">mdi-close</v-icon>
          Kapat
        </v-btn>
        <v-btn small color="green" dark :loading="shippingUpdateLoading" @click="updateShippingDetail">
          <v-icon size="1.25rem" class="mr-1">mdi-refresh</v-icon>
          Kargo Bilgisini Güncelle
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>

</style>